<template>
  <div class="welcome-step">
    <div class="welcome-step__header">
      <img
        class="main-header__logo"
        :src="configDataDefaultBrand.assets.logo"
        alt="Логотип"
      />
      <h1 class="h1 color-white">
        {{ t("auth.welcome.titleLine1") }}<br />
        {{ t("auth.welcome.titleLine2") }}
      </h1>
    </div>
    <div>
      <button
        class="color-secondary caption-small--bold welcome-step__btn-auth"
        @click="$emit('login')"
      >
        {{ t("auth.welcome.login") }}
      </button>
      <BaseButton
        v-if="!isDesktop"
        :title="t('auth.welcome.activateSim')"
        size="large"
        color="transparent-white"
        @click="goToIdAbonent(adaptiveLink)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from "@/components/base/BaseButton.vue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";

const { t } = useI18n();
const store = useStore();

const goToIdAbonent = (link: string) => {
  window.open(link, "_blank");
};

const isDesktop = ref<boolean>(true);
const adaptiveLink = ref<string>("");

const configDataDefaultBrand = computed(
  () => store.getters["brand/configDataDefaultBrand"]
);

const systemCheck = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    isDesktop.value = false;
    return "https://itunes.apple.com/ru/app/id1368190117?mt=8";
  }

  // Check for Android
  if (/android/i.test(userAgent)) {
    isDesktop.value = false;
    return "https://play.google.com/store/apps/details?id=ru.world.idabonent";
  }

  // Default to desktop
  isDesktop.value = true;
  return "";
};

onMounted(() => {
  adaptiveLink.value = systemCheck();
  console.log(adaptiveLink.value);
});
</script>

<style scoped lang="scss">
@import "@/assets/style/main";

.welcome-step {
  padding: 64px 24px 29px 24px;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  background: var(--gradient-main);
  border-radius: 32px;
  @media (max-width: 650px) {
    border-radius: 0;
    padding: 29px 24px 29px 24px;
  }

  &__btn-auth {
    display: flex;
    background-color: var(--color-white);
    align-items: center;
    justify-content: center;
    padding: 20px 0 18px 0;
    border-radius: 30px;
    text-transform: uppercase;
    margin: 0;
  }
}

.main-header__logo {
  display: none;
  @media (max-width: 650px) {
    display: flex;
    width: 74px;
    height: 41px;
    margin-bottom: 37px;
  }
}

button {
  width: 100%;
  margin: 10px 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
</style>
